import { render, staticRenderFns } from "./ImageModalImage.vue?vue&type=template&id=44ada3b2"
import script from "./ImageModalImage.vue?vue&type=script&lang=js"
export * from "./ImageModalImage.vue?vue&type=script&lang=js"
import style0 from "./ImageModalImage.vue?vue&type=style&index=0&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports